import React, { useEffect } from "react";
import Modal from "react-modal";
import "./style.css";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
//   Modal.setAppElement('#yourAppElement');
function Quitpopup(props) {
  let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);

  useEffect(() => {
    setIsOpen(props.open);
  }, [props.open]);

  function openModal() {
    setIsOpen(true);
  }

  //   function afterOpenModal() {
  //     // references are now sync'd and can be accessed.
  //     subtitle.style.color = "#f00";
  //   }

  function closeModal() {
    setIsOpen(false);
    props.resume();
    props.setValue(false);
  }
  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        className={"quit"}
      >
        <button className="closeModal" onClick={closeModal}>
          <img src={require("../../../Assets/img/corss-modal.png")} />
        </button>
        <img src={require("../../../Assets/img/warn.png")} className="warn" />
        <p>Are you Sure You want to quit this game?</p>
        <div className="btnMainButton">
          <button className="blueBtn" onClick={() => props.Quit()}>
            <img src={require("../../../Assets/img/back.png")} /> Quit Game
          </button>
        </div>
      </Modal>
    </>
  );
}

export default Quitpopup;
